import type {Brand, Environment} from '../../../types'
import type {HostMap} from '../types'
import {YANDEX} from './by-brand/yandex'
import {YANDEXCOM} from './by-brand/yandexcom'
import {YANGO} from './by-brand/yango'
import {PRODUCTION} from './production'
import {TESTING} from './testing'
import {UNSTABLE} from './unstable'

export const BY_ENVIRONMENT = {
  unstable: UNSTABLE,
  testing: TESTING,
  production: PRODUCTION,
} satisfies Record<Environment, HostMap>

export const BY_BRAND_BY_ENVIRONMENT = {
  yandex: YANDEX,
  yandexcom: YANDEXCOM,
  yango: YANGO,
} satisfies Record<Brand, Record<Environment, HostMap>>
